var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,23h-6v-2h5V3H5V21h5v2H4l-1-1V2l1-1H20l1,1V22l-1,1Zm-3-18h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm8,5h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm8,5h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm-4,0h-2v3h2v-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/1778142529/media/icon-company.6bebf33d3487f67f249fb696e96ce044.svg";
export { ForwardRef as ReactComponent };